// extracted by mini-css-extract-plugin
export default {"container":"MergeSelectionBar_container__C3r9u","countBadge":"MergeSelectionBar_countBadge__l8+wc"};